/**
 * Links Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initLinks() {
    const blocks = document.querySelectorAll(".links");

    blocks.forEach((block) => {
      // Add your block functionality here
      console.log("[BLOCK] links block initialized");
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLinks);
  } else {
    initLinks();
  }
})();
